import useCrud from 'hooks/useCrud';
import { enterprise, updateEnterprise } from 'services/api/admin';

function useEnterprise() {
  return useCrud({
    read: enterprise,
    update: updateEnterprise,
  });
}

export default useEnterprise;
